/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';

/**
 * 
 * @export
 * @interface PlaylistTracksResponse
 */
export interface PlaylistTracksResponse {
    /**
     * 
     * @type {Array<Track>}
     * @memberof PlaylistTracksResponse
     */
    data?: Array<Track>;
}

/**
 * Check if a given object implements the PlaylistTracksResponse interface.
 */
export function instanceOfPlaylistTracksResponse(value: object): value is PlaylistTracksResponse {
    let isInstance = true;

    return isInstance;
}

export function PlaylistTracksResponseFromJSON(json: any): PlaylistTracksResponse {
    return PlaylistTracksResponseFromJSONTyped(json, false);
}

export function PlaylistTracksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistTracksResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TrackFromJSON)),
    };
}

export function PlaylistTracksResponseToJSON(value?: PlaylistTracksResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TrackToJSON)),
    };
}

